import React from "react";
import ImagePost from "./imagepost";
import HtmlPost from "./htmlpost";
import VideoPost from "./videopost";
import CardContainer from "./cardcontainer";
import ROUTES from "../../../router/routes";

const Highlightcard = ({ data }) => {
  const post = data.highlightPost[0];
  if (post) {
    return post.content_type === "Image" ? (
      <ImagePost
        post={post}
        href={ROUTES.GET_HIGHLIGHT_URL(data.id)}
        target="_blank"
      />
    ) : post.content_type === "HTML" ? (
      <HtmlPost
        post={post}
        href={ROUTES.GET_HIGHLIGHT_URL(data.id)}
        target="_blank"
      />
    ) : post.content_type === "Video" ? (
      <VideoPost
        post={post}
        href={ROUTES.GET_HIGHLIGHT_URL(data.id)}
        target="_blank"
      />
    ) : (
      <CardContainer />
    );
  }
  return null;
};

export default Highlightcard;
